import { useState, type ReactNode } from 'react';
import { NavLink } from '../NavLink';
import LeftArrow from '../icons/arrow-left.svg?react';
import { Body3 } from '../typography';
import { cn } from '../utils';

interface MobileSubmenuNavLinkProps {
  text: ReactNode;
  menuTitle: string;
  children: ReactNode;
}
export const MobileSubmenuNavLink = ({
  text,
  menuTitle,
  children,
}: MobileSubmenuNavLinkProps) => {
  const [isOpen, setOpen] = useState(false);
  const onToggle = () => {
    setOpen(!isOpen);
  };
  return (
    <>
      <NavLink withIcon onClick={onToggle}>
        {text}
      </NavLink>
      <div
        className={cn(
          'z-9 bg-grey-5 dark:bg-slate-70 duration-250 absolute bottom-0 left-0 right-0 top-80 transform p-16 transition-transform ease-out md:top-96 md:p-32',
          isOpen ? 'translate-x-0' : 'translate-x-full',
        )}
      >
        <header className="text-text-primary relative mb-28 flex justify-center">
          <LeftArrow
            className="absolute left-0 cursor-pointer"
            onClick={onToggle}
          />
          <Body3 caps>{menuTitle}</Body3>
        </header>
        <div className="m-0 flex list-none flex-col items-start gap-28 p-0">
          {children}
        </div>
      </div>
    </>
  );
};
